import type { ReactNode } from 'react'

interface Props {
  title: string
  subtitle?: string
  children?: ReactNode
}

/** Cabeçalho consistente das telas do Modo Obra. */
export function ObraPageHeader({ title, subtitle, children }: Props) {
  return (
    <header className='cf3-obra-section-hero'>
      <div className='cf3-obra-section-hero__main'>
        <h1 className='cf3-obra-section-hero__title'>{title}</h1>
        {subtitle && <p className='cf3-obra-section-hero__sub'>{subtitle}</p>}
      </div>
      {children && <div className='cf3-section-hero__actions'>{children}</div>}
    </header>
  )
}
